import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.scss'],
  standalone: false
})
export class PatientComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
